import React from "react";
import { scrollToId } from "../utils/scroll";

const MEETING_MONTHS = [
  {
    name: "September",
    note: "The autumn opening — first meeting after the summer recess.",
  },
  {
    name: "November",
    note: "Often a Remembrance-themed meeting, with the RAF dinner nearby.",
  },
  { name: "February", note: "A welcome midwinter gathering at Knowle." },
  {
    name: "April",
    note:
      "The Installation meeting — when we install the next Worshipful Master.",
  },
];

function Meetings() {
  return (
    <section id="meetings" className="section section--paper2">
      <div className="container">
        <div style={{ maxWidth: "68ch" }}>
          <p className="eyebrow">When &amp; where we meet</p>
          <h2>Four meetings a year &mdash; always a Monday.</h2>
          <p className="lede">
            We meet on the <strong>second Monday</strong> of{" "}
            <strong>September, November, February and April</strong> at the Knowle
            Masonic Centre. Visiting brethren and prospective members are always welcome
            &mdash; do drop us a line beforehand so we can roll out the proverbial red
            carpet.
          </p>
        </div>

        <div className="meeting-grid">
          {MEETING_MONTHS.map((m) => (
            <article className="meeting-card" key={m.name}>
              <p className="meeting-card__when">2nd Monday</p>
              <h3 className="meeting-card__month">{m.name}</h3>
              <p className="meeting-card__note">{m.note}</p>
            </article>
          ))}
        </div>

        <div className="meeting-foot">
          <div>
            <p className="eyebrow">Venue</p>
            <h3 style={{ marginTop: 4 }}>Knowle Masonic Centre</h3>
            <p style={{ margin: 0, color: "var(--muted)" }}>
              1621 Warwick Road, Knowle, Solihull B93&nbsp;9LF
            </p>
          </div>
          <a
            className="btn btn--ghost"
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              scrollToId("contact");
            }}
          >
            Plan a visit <span className="arrow" aria-hidden="true">→</span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Meetings;
